import React from "react";

/* eslint-disable react/jsx-props-no-spreading */

const UiStatesContext = React.createContext([]);

const defaultUiState = {
  pageTitle: "",
  pageParentTitle: "",
  audioGuideGroups: {},
  audioGuideMode: "grid",
  audioGuideFilter: ""
};

function uiReducer(state, action) {
  switch (action.type) {
    case "SET_PAGE_TITLE": {
      const pageTitle = action.pageTitle || "";
      const pageParentTitle = action.pageParentTitle || "";
      return { ...state, pageTitle, pageParentTitle };
    }

    case "EXPAND_AUDIO_GUIDE_GROUP": {
      const newAudioGuideGroups = { ...(state.audioGuideGroups || {}) };
      newAudioGuideGroups[`${action.guideId}-${action.groupId}`] = true;
      return { ...state, audioGuideGroups: newAudioGuideGroups };
    }

    case "COLLAPSE_AUDIO_GUIDE_GROUP": {
      const newAudioGuideGroups = { ...(state.audioGuideGroups || {}) };
      newAudioGuideGroups[`${action.guideId}-${action.groupId}`] = false;
      return { ...state, audioGuideGroups: newAudioGuideGroups };
    }

    case "SET_AUDIO_GUIDE_MODE": {
      if (
        !action.mode ||
        !action.mode.length ||
        ["grid", "list"].indexOf(action.mode) < 0
      ) {
        throw new Error(
          `SET_AUDIO_GUIDE_MODE: Unsupported display mode: ${action.mode ||
            "NO MODE PROVIDED"}`
        );
      }
      return { ...state, audioGuideMode: action.mode };
    }

    case "SET_AUDIO_GUIDE_FILTER": {
      if (
        !action.filter ||
        !action.filter.length ||
        ["none", "has_audio"].indexOf(action.filter) < 0
      ) {
        throw new Error(
          `SET_AUDIO_GUIDE_FILTER: Unsupported filter: ${action.filter ||
            "NO FILTER PROVIDED"}`
        );
      }
      return { ...state, audioGuideFilter: action.filter };
    }

    default: {
      throw new Error(`Unsupported action type: ${action.type}`);
    }
  }
}

export const useUiState = () => {
  const context = React.useContext(UiStatesContext);

  if (!context) {
    throw new Error(`useUiState must be used within UiStatesContext`);
  }

  const [state, dispatch] = context;
  return { state, dispatch };
};

export const UiStatesContextProvider = props => {
  const [state, dispatch] = React.useReducer(uiReducer, defaultUiState);
  const value = React.useMemo(() => [state, dispatch], [state]);
  return <UiStatesContext.Provider value={value} {...props} />;
};
